import { fetchWrapper } from "@/helpers";
const ruta = process.env.VUE_APP_ROOT_API;

export default class MermaService {
    async getAll() {
        return await fetchWrapper.get(`${ruta}/mermas`);
    }
    async getById(id) {
        return await fetchWrapper.get(`${ruta}/mermas/${id}`);
    }
    async create(merma) {
        return await fetchWrapper.post(`${ruta}/mermas`, merma);
    }
    async update(merma) {
        return await fetchWrapper.put(`${ruta}/mermas/${merma.id}`, merma);
    }
    async delete(id) {
        return await fetchWrapper.delete(`${ruta}/mermas/${id}`);
    }
}
